import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import {
  Icon,
  IconColor,
  IconSize,
} from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { MiniTitle } from '@delmonicos/shared-design-system-react/src/components/typography/mini-title/mini-title';
import {
  Text,
  TextColor,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';

import { useEmspBoChargingSessionContext } from '../../emsp-bo-charging-session.context';

export const SessionLocationCardComponent = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const navigate = useNavigate();
  const chargingSession = useEmspBoChargingSessionContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleGoToLocation = () => {
    if (!chargingSession.locationId) return;
    navigate(
      generatePath(APP_PATH.LOCATION.DETAILS, {
        id: chargingSession.locationId,
      }),
    );
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Card flex={1}>
      <Stack direction="column" gap={GapEnum.L}>
        <AccentTitle
          icon="map-01"
          text={t('$.emsp-bo-charging-session-details.session-type-card.title')}
          as={HeadingEnum.H2}
          variant={AccentVariantEnum.Primary}
        />
        <Stack alignItems="center" justifyContent="space-between">
          <Stack alignItems="center" gap={GapEnum.XS} flex={1}>
            <Icon
              color={IconColor.Secondary}
              iconSize={IconSize.Small}
              name="map-01"
            />
            <MiniTitle color={TextColor.Secondary}>
              {t(
                'delmonicos-shared-sdk.outputs-charging-session.location-name',
              )}
            </MiniTitle>
          </Stack>
          <Stack flex={2}>
            <Link
              onClick={handleGoToLocation}
              disabled={!chargingSession.locationId}>
              {chargingSession.locationName ?? '-'}
            </Link>
          </Stack>
        </Stack>
        <Stack alignItems="center" justifyContent="space-between">
          <Stack alignItems="center" gap={GapEnum.XS} flex={1}>
            <Icon
              color={IconColor.Secondary}
              iconSize={IconSize.Small}
              name="building-02"
            />
            <MiniTitle color={TextColor.Secondary}>
              {t(
                'delmonicos-shared-sdk.outputs-charging-session.location-city',
              )}
            </MiniTitle>
          </Stack>
          <Stack flex={2}>
            <Text>{chargingSession.locationCity ?? '-'}</Text>
          </Stack>
        </Stack>
        <Stack alignItems="center" justifyContent="space-between">
          <Stack alignItems="center" gap={GapEnum.XS} flex={1}>
            <Icon
              color={IconColor.Secondary}
              iconSize={IconSize.Small}
              name="electric-terminal"
            />
            <MiniTitle color={TextColor.Secondary}>
              {t('delmonicos-shared-sdk.outputs-charging-session.evse-uid')}
            </MiniTitle>
          </Stack>
          <Stack flex={2}>
            <Text>{chargingSession.evseUid ?? '-'}</Text>
          </Stack>
        </Stack>
        <Stack alignItems="center" justifyContent="space-between">
          <Stack alignItems="center" gap={GapEnum.XS} flex={1}>
            <Icon
              color={IconColor.Secondary}
              iconSize={IconSize.Small}
              name="wire"
            />
            <MiniTitle color={TextColor.Secondary}>
              {t('delmonicos-shared-sdk.outputs-charging-session.connector-id')}
            </MiniTitle>
          </Stack>
          <Stack flex={2}>
            <Text>{chargingSession.connectorId ?? '-'}</Text>
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
};
